import { useState } from 'react';
import { PageHeader } from '@/components/shared/page-header';
import { LocationBadge } from '@/components/shared/location-badge';
import { ProductForm } from './product-form';
import { useCreateProduct } from '@/hooks/use-products';
import { toast } from '@/stores/toast-store';

export function ProductCreatePage() {
  const createProduct = useCreateProduct();

  // Check for clone data from duplicate action (UPC/SKU cleared)
  // useState initializer runs exactly once — safe against React StrictMode double-invoke
  const [cloneData] = useState<any>(() => {
    try {
      const raw = sessionStorage.getItem('product-clone');
      if (raw) {
        sessionStorage.removeItem('product-clone');
        return JSON.parse(raw);
      }
    } catch {
      /* ignore */
    }
    return undefined;
  });

  const handleSubmit = async (formData: any) => {
    try {
      await createProduct.mutateAsync(formData);
      const unitCount = formData.units?.length ?? 0;
      const total = 1 + unitCount;
      toast.success(`${total} product${total > 1 ? 's' : ''} created successfully`);
      window.location.hash = '#/pos-management';
    } catch (err: any) {
      // ProductForm catches these 409 codes and pins the message to the
      // offending input (barcode or SKU), so we rethrow without toasting.
      const code = err?.error?.code;
      if (code === 'DUPLICATE_PRIMARY_BARCODE' || code === 'DUPLICATE_SKU') {
        throw err;
      }
      const message = err?.error?.message || err?.error?.details?.[0]?.message;
      if (message && !message.includes('Internal server error')) {
        toast.error(message);
      }
    }
  };

  return (
    <div className="space-y-6">
      <PageHeader title={cloneData ? 'Duplicate Product' : 'Create Product'} backTo="#/pos-management">
        <LocationBadge />
      </PageHeader>
      <ProductForm initialData={cloneData} onSubmit={handleSubmit} isSubmitting={createProduct.isPending} />
    </div>
  );
}
